<app-header [forceLightBackground]="true"></app-header>
<div class="provider-access-requests">
  <div class="provider-access-requests--layout">
    <app-provider-sidebar class="provider-access-requests--sidebar"></app-provider-sidebar>
    <div class="provider-access-requests--content">
      <app-page-header></app-page-header>
      <app-asset-request
        [showPurposeColumn]="false"
        [showRequestTypeColumn]="false"
        [hideHorizontalScroll]="true"
        (reloadData)="loadProviderAssetRequests()"
      ></app-asset-request>
    </div>
  </div>
</div>



